import React, { useEffect, useState } from 'react';
import { getAllCookies } from '../AppUtils/CreateOpportunitiesUtils/cookies'; // Import the cookie utility
import RecruitmentHelper from '../AppUtils/RecruitmentHelperEmailAutomationUtils/RecruitmentHelper';

function RecruitmentHelperEmailAutomation() {
  const [cookies, setCookies] = useState({});

  useEffect(() => {
    const allCookies = getAllCookies();
    setCookies(allCookies);
  }, []);

  return (
    <div>
      <RecruitmentHelper name={cookies.name} />
    </div>

  );
}

export default RecruitmentHelperEmailAutomation;